<template>
  <div class="mine_page">
    <van-nav-bar :title="$t('q60')" class="header_b"></van-nav-bar>
    <div class="u_bg"></div>
    <div class="content_re">
    <div class="info_card_u">
      <div class="left_c">
        <div class="user_img_b" v-if="userInfo.header_img">
          <img src="/img/neww/userpic.png" alt="" class="user_set"/>
        </div>
        <div class="user_img_b" v-if="!userInfo.header_img">
          <img src="/img/neww/userpic.png" alt="" class="user_set"/>
        </div>
        
        <div class="tc">
          <div class="">{{userInfo.username}}</div>
          <div class="c_c">{{userInfo.vip}}</div>
        </div>
      </div>
      <img src="/img/neww/download (1).png" @click="$router.push({path:'/IndexInfo'});" class="c_set"/>
    </div>
    <div class="c_card_b">
      <div class="hang_c">
        <div class="q1">{{ $t("q5") }}</div>
        <div class="q2">{{Number(Number(userInfo.money)+Number(userInfo.free_money)).toFixed(2)}}</div>
      </div>
      <div class="hang_c">
        <div class="q1">{{ $t("q6") }}</div>
        <div class="q2">{{userInfo.xinyu}}</div>
      </div>
    </div>
    <div class="c_vip">
      <div class="ee">{{ $t("q7") }}</div>
      <div class="down">{{ $t("q8") }}</div>
    </div>
    <div class="hang_bttn" @click="$router.push({path:'/Withdraw'});">
      <div class="left_y" >
        <img src="/img/neww/ico_txzx.png" alt="" class="cl_set"/>
        <div class="text_k">{{ $t("q9") }}</div>
      </div>
      <img src="/img/neww/you.png" alt="" class="right_h"/>
    </div>
    <div class="hang_bttn" @click="$router.push({path:'/Personalreport'});">
      <div class="left_y">
        <img src="/img/neww/222.png" alt="" class="cl_set"/>
        <div class="text_k">{{ $t("q61") }}</div>
      </div>
      <img src="/img/neww/you.png" alt="" class="right_h"/>
    </div>
    <div class="hang_bttn" @click="$router.push({path:'/GameRecord'});">
      <div class="left_y">
        <img src="/img/neww/ico_bb.png" alt="" class="cl_set"/>
        <div class="text_k">{{ $t("q10") }}</div>
      </div>
      <img src="/img/neww/you.png" alt="" class="right_h"/>
    </div>
    <div class="hang_bttn" @click="$router.push({path:'/RechargeList'});">
      <div class="left_y">
        <img src="/img/neww/ico_czjl.png" alt="" class="cl_set"/>
        <div class="text_k">{{ $t("q11") }}</div>
      </div>
      <img src="/img/neww/you.png" alt="" class="right_h"/>
    </div>
    <!-- @click="toNotice()" -->
    <div class="hang_bttn"  @click="$router.push({path:'/WithdrawRecord'});"> 
      <div class="left_y">
        <img src="/img/neww/ico_tkjl.png" alt="" class="cl_set"/>
        <div class="text_k">{{ $t("q12") }}</div>
      </div>
      <img src="/img/neww/you.png" alt="" class="right_h"/>
    </div>
    <div class="hang_bttn" @click="$router.push({path:'/BindCard'});">
      <div class="left_y">
        <img src="/img/neww/icon_user_card.png" alt="" class="cl_set"/>
        <div class="text_k">{{ $t("q13") }}</div>
      </div>
      <img src="/img/neww/you.png" alt="" class="right_h"/>
    </div>
    <div class="hang_bttn" @click="$router.push({path:'/ServiceOnline'});">
      <div class="left_y">
        <img src="/img/neww/kefu.png" alt="" class="cl_set"/>
        <div class="text_k">{{ $t("q82") }}</div>
      </div>
      <img src="/img/neww/you.png" alt="" class="right_h"/>
    </div>

  </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      userInfo: {
      },
      menu_top: 40,
      isLoading: false,
    };
  },
  methods: {
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: '/Login' })
        }
      }, 500);
    },
    exit() {
      this.$toast(this.$t("my.finish_task"));
    },
    showSetting() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Setting' })
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    toNotice() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Notice' })
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: '/Login' })
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Infomation' });
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    doPay() {
      this.$router.push({
        name: 'Recharge',
        params: {
          'balance': this.userInfo.money
        }
      })
    },
    doWithdrawal() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.data.is_bank) {
          this.$router.push("withdraw");
        } else {
          this.$router.push("Setbank");
          this.$toast.fail(this.$t("setting.set_bank"));
        }
      })
    },
    toService() {
      console.log(this.$store.getters.getBaseInfo)
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("Withdraw");
      } else {
        this.$toast.fail(this.$t("setting.forbid"));
      }
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          console.log(this.userInfo,"this.userInfo---174");
          this.menu_top = 15;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear()
            this.$router.push({ path: '/Login' })
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },

  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo();
    } else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  }
};
</script>

<style scoped lang="less">
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}

.mine_page {
      position: relative;
    background-color: #101012;
    top: 60px;
    height: 100vh;
    max-width: 600px;
    margin: 0 auto;
    box-sizing: border-box;
  .content_re{
    position: absolute;
    width: 100%;
    padding-bottom: 100px;

  }
  .header_b{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }
  .u_bg {
 
    background: linear-gradient(to right, #efcba7, #dcab76);
    height: 170px;
    position: absolute;
    width: 100%;
    // z-index: -1;
  }
  .hang_bttn{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: .85rem 1.8rem;
    border-bottom: 1px solid #333;
    .left_y{
      display: inline-flex;
      align-items: center;
      color: #e6b98a;
      .cl_set{
        height: 2rem;
        margin-right: 20px;
      }
    }
    .right_h{
      height: 1.5rem;
    }
  }
  .c_card_b{
    display: flex;
    align-items: center;
    background: linear-gradient(120deg,#212121,#313131);
    border-radius: 10px;
    margin: 0 30px;
    padding: 1rem 0;
    .hang_c{
      flex:1;
      text-align: center;
      .q1{
        color: #fff;
      }
      .q2{
        color: #e6b98a;
        padding-top: 24px;
      }
    }
  }
  .c_vip{
    display:none;
    margin: 20px 40px;
    background: url('/img/neww/user-bg.png') no-repeat center center;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 40px 40px 40px 40px;
    color: #e6b98a;
    .ee{
      font-size: 24px;
    }
    .down{
      font-size: 28px;
    }
  }
  .info_card_u{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 60px 1rem 2rem;
    .left_c{
      display: inline-flex;
      align-items: center;
      .user_set{
        width: 5rem;
        border: 2px solid #fff;
        border-radius: 50%;
      }
      .tc{
        margin-left: 30px;
        .c_c{
          padding-top: 16px;
        }
      }
    }
    .c_set{
      width: 1.5rem;
    }
  }
  .c_card_b{
    background-color: #fff;
  }
}



.mine {
  position: relative;
  bottom: 20px;

  /* background: url('/img/usertop.660cec17.png') no-repeat top -16vw center; */
  .page-bg {
    background: linear-gradient(to right, #efcba7, #dcab76);
  }
}

.mine .wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.nav-bar {
  /* background: linear-gradient(
      90deg,#7e5678,#e6c3a1); */
  background: content-box;
}

.mine .header {

  padding-bottom: 100px;
  background-size: contain
}

::v-deep .van-nav-bar__content {
  height: 60px;
  .van-nav-bar__title{
    font-size:1rem;
  }
}

::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0px;
}

.mine .header .van-nav-bar .van-icon {
  font-size: 45px;
}

.mine .header .user-wrapper {
  display: flex;
  align-items: center;
  margin: 0px 40px 0px 40px;

}

.mine .user_img {
  height: 130px;
  width: 130px;
}

::v-deep .van-loading__spinner {
  height: 50px;
  width: 50px;
}

::v-deep .van-image__error-icon {
  font-size: 70px;
}

.mine .header .user-wrapper .login-content {
  flex: 1;
  margin-left: 30px;
}

.mine .header .user-wrapper .login-content .login-btn {
  display: inline-block;
  font-size: 40px;
  line-height: 0px;
  color: #fff;
}

.mine .header .user-wrapper .login-content .login-label {
  margin-top: -13px;
  font-size: 28px;
  color: hsla(0, 0%, 100%, .6);
}

.mine .page-bg {
  height: 500px;

}

.mine .content {
  position: relative;
  padding: 10px 30px 30px;
  min-height: 500px;
  background-color: #f2f2f5;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #ffffff;
  font-size: 35px;
}

.mine .wrapper .content .finance {
  position: absolute;
  display: flex;
  align-items: center;
  top: -55px;
  left: 30px;
  right: 30px;
  height: 120px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .finance .line {
  width: 3px;
  height: 40px;
  background-color: #ccc;
}

.mine .wrapper .content .finance .finance-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.mine .wrapper .content .finance .finance-item .text {
  margin-left: 30px;
  font-size: 30px;
  color: #000;
  font-weight: 500;
}

.mine .wrapper .content .finance .finance-item .icon {
  font-size: 50px;
}

.mine .wrapper .content .menu {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .menu .menu-item {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 33.3%;
  height: 180px;
}

.mine .wrapper .content .menu .menu-item .menu-item-label {
  font-size: 24px;
  color: #432788;
  font-weight: 500;
}

.mine .wrapper .content .menu .menu-item .menu-item-icon {
  margin: 25px;
  width: 60px;
  height: 60px;
  -o-object-fit: contain;
  object-fit: contain;
}

.mine .wrapper .content .wallet {
  margin-top: 80px;
  padding: 0 30px;
  background-color: #a06098;
  border-radius: 15px;

  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .wallet .part-1 {
  display: flex;
  align-items: center;
  height: 100px;
}

.mine .wrapper .content .wallet .font-primary-color {
  color: #fff;
  font-size: 32px;
}

.font-gray {
  color: #fff;
  font-size: 28px;
}

.mine .wrapper .content .wallet .part-2 {
  display: flex;
  align-items: center;
  height: 10px;
}

.mine .wrapper .content .wallet .part-3 {
  display: flex;
  align-items: center;
  height: 80px;
}

.mine .wrapper .content .wallet .part-2 .balance {
  flex: 1;
  font-size: 60px;
  color: #fff;
  font-weight: 700;
}

/* .mine .wrapper .content .wallet .van-hairline--bottom::after {
  border-bottom-width: 3px;
} */
.mine .wrapper .content .wallet .part-2 .refresh-btn {
  margin-left: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  font-size: 30px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #e6c3a1;
}

.btn {
  margin: 40px 0;
}
</style>
<style lang="less" scoped>
.van-nav-bar {
  background-color: #1c1c1c;
}

.mine.page {
  padding-top: 50px;
}
</style>
